import { useState, useEffect, useCallback } from 'react';
import { renewalsAPI } from '../services/api';

export function useRenewals() {
  const [upcoming, setUpcoming] = useState([]);
  const [stats, setStats] = useState({ total_checks: 0, active_recommendations: 0, completed_switches: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [up, st] = await Promise.all([renewalsAPI.getUpcoming(20), renewalsAPI.getStats()]);
      setUpcoming(Array.isArray(up) ? up : []);
      setStats(st && typeof st === 'object' ? st : { total_checks: 0, active_recommendations: 0, completed_switches: 0 });
      if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('renewals_cached_at', new Date().toISOString());
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Failed to load renewals');
      setUpcoming([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { upcoming, stats, loading, error, reload: load };
}
